module.exports = __webpack_public_path__ + "static/media/undo-dark.6682f816.svg";